
let ModeFieldSelectorWidget = function(args, modes) {

    let currentFieldBody = args.annotation ?
        args.annotation.bodies.find(function(b) {
            return b.purpose == 'field';
        }) : null;

    // 2. Keep the value in a variable
    let currentField = currentFieldBody ? currentFieldBody.value : null;

    let fields = modes?.fields ?? [];
    let container = document.createElement('div')
    container.className = 'p-1 '

    let selectGroup = document.createElement('div')
    selectGroup.className = 'form-group'
    
    let label = document.createElement('label')
    label.setAttribute('for', 'selectFields')
    label.textContent = 'Competência'

    let select = document.createElement('select')
    select.setAttribute('id', 'selectFields')
    select.className = 'custom-select form-control'
    if(args.readOnly){
        select.disabled = true
    }
    
    let defaultOption = document.createElement('option')
    defaultOption.value = ''
    defaultOption.text = 'Selecione uma competência' 


    let onSelectValue = (evt) => {
        select.dataset.option = evt.target.value

        if(currentFieldBody){
            args.onUpdateBody(currentFieldBody, {
                type: 'TextualBody',
                purpose: 'field',
                value: evt.target.value
            });
        }
        else {
            args.onAppendBody({
                type: 'TextualBody',
                purpose: 'field',
                value: evt.target.value
            });
        }

    }
    

    

    
    if(fields.length > 0){
        
        select.append(defaultOption);

        fields.map(field => {
            let option = document.createElement('option')
            option.value = field.id
            option.text = field.description
            if(currentField === String(field.id)){
                option.selected = true
            }
            
            select.append(option);
        })
        
        selectGroup.append(label)
        selectGroup.append(select)
        
    }

    select.onchange = (evt) => onSelectValue(evt)
    
    container.append(selectGroup);

    
    return container
}

export default ModeFieldSelectorWidget;
